import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./style.css";
import filter from "../../../images/icons/filter.png";
import Pagination from "../../../components/Pagination";
import editIcon from "../../../images/icons/edit.png";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Modal from "react-bootstrap/Modal";
import view from "../../../images/view.png";
import UserAdd from "./Add";
import UserEdit from "./Edit";
import UserEditView from "./view";
import Swal from "sweetalert2";
import {
  apiCancelUser,
  apiClearDevice,
  apiListBranch,
  apiListCompany,
  apiListGodown,
  apiListUser,
} from "../../../api/master";
import { removeEmptyFields } from "../../../utils";
import $ from "jquery";
import { TbCircleArrowUpRight } from "react-icons/tb";

function UserList() {
  const initialState = {
    user_name: "",
    is_active: "",
    user_mob: "",
  };

  const [user, setUser] = useState({});

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showId, setShowId] = useState(0);
  const [editId, setEditId] = useState("");
  const [list, setList] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [roleList, setRoleList] = useState([]);

  const [formInputs, setFormInputs] = useState(initialState);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  function changeStatus(user_id, status) {
    let target = window.event.target;
    let oldText = target.innerText;
    target.innerText = "Updating...";
    apiCancelUser({ user_id: user_id, is_active: status })
      .then((data) => {
        setError("");
      })
      .catch((err) => {
        setError(err.response.data.data.message);
        setTimeout(function () {
          setError("");
        }, 3000);
      })
      .finally(() => {
        target.innerText = oldText;
        getList(filtersVisible);
      });
  }
  function clearDevice(user_id, status) {
    let target = window.event.target;
    let oldText = target.innerText;
    target.innerText = "Updating...";
    apiClearDevice({ user_id: user_id })
      .then((data) => {
        // setSuc
        console.log("data?.datadata?.data", data?.data);
        setSuccess(data?.data?.data);
        setError("");
        setTimeout(function () {
          setSuccess("");
        }, 4000);
      })
      .catch((err) => {
        setError(err.response.data.data.message);
        setTimeout(function () {
          setError("");
        }, 3000);
      })
      .finally(() => {
        target.innerText = oldText;
        getList(filtersVisible);
      });
  }

  async function getList(isFilter = true, pageNo = null) {
    let json = { paginate: 1, page_no: (pageNo || currentPage) - 1 };
    if (user.role_id === 1) {
      json = { ...json, role_id: 2 };
    }
    if (isFilter) {
      json = { ...json, ...formInputs };
    }
    json = removeEmptyFields(json);
    await apiListUser(json)
      .then((data) => {
        setCurrentPage(pageNo || currentPage);
        setIsSubmit(false);
        setList(data.data.data.list);
        setIsLoading(false);
        setTotalPage(data.data.data.count);
      })
      .catch(function (err) {
        setIsSubmit(false);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      });
  }

  const roleListIng = [
    { id: 1, title: "Super Admin", role_id: 0 },
    { id: 2, title: "Admin", role_id: 1 },
    { id: 3, title: "Branch Owner", role_id: 2 },
    { id: 4, title: "Cashier", role_id: 2 },
    { id: 5, title: "Godown Manager", role_id: 2 },
    { id: 7, title: "Associate Cashier", role_id: 2 },
    { id: 8, title: "No Cash Cashier", role_id: 2 },
    { id: 9, title: "Cash Expense Cashier", role_id: 2 },
    { id: 10, title: "Connector", role_id: 2 },
  ];

  const [compList, setCompList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [godownList, setGodownList] = useState([]);

  console.log("compListcompList", compList);

  async function CompanyList() {
    await apiListCompany({ paginate: 0 }).then((result) =>
      setCompList(result?.data?.data.list),
    );
  }

  async function godowLists() {
    await apiListGodown({ paginate: 0, is_active: 1 })
      .then((data) => setGodownList(data?.data?.data?.list))
      .catch((err) => {});
  }

  async function branchLists() {
    await apiListBranch({ paginate: 0 })
      .then((data) => setBranchList(data?.data?.data?.list))
      .catch((err) => {});
  }

  const companyListMap = compList?.flatMap((el) => {
    return {
      ...el,
      value: el?.comp_id,
      label: el.comp_name,
      access: el?.access_code_permission,
    };
  });

  const brList = branchList?.flatMap((el) => {
    return {
      ...el,
      label: el?.branch_name,
      value: el?.branch_id,
    };
  });

  const godowList = godownList?.flatMap((el) => {
    return {
      ...el,
      label: el?.godown_name,
      value: el?.godown_id,
      branch_id: el?.branch_id,
    };
  });

  useEffect(function () {
    CompanyList();
    godowLists();
    branchLists();
  }, []);

  useEffect(
    function () {
      if (user?.role_id) {
        getList(false);
      }
    },
    [currentPage, user],
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  const handlePaste = (event) => {
    const pastedText = event.clipboardData.getData("text/plain");
    const onlyNumbers = pastedText.replace(/\D/g, "");
    event.preventDefault();
    document.execCommand("insertText", false, onlyNumbers);
  };

  let lastKey = null;
  function inputNumber(e) {
    let allowKeys = [
      "Tab",
      "Backspace",
      "Delete",
      "Enter",
      "ArrowUp",
      "ArrowDown",
      "ArrowLeft",
      "ArrowRight",
      "Control",
    ];

    if (
      (e.ctrlKey || e.metaKey) &&
      ["c", "x", "v", "a"].includes(e.key.toLowerCase())
    ) {
      return true;
    }

    if (!($.isNumeric(e.key) || allowKeys.includes(e.key))) {
      e.preventDefault();
    }

    lastKey = e.key;
  }

  return (
    <>
      <div
        className="d-flex min-vh-100 main-Wrapper"
        style={{ background: "#DAE5FF" }}
      >
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />

          <main className="bg-white rounded-4" id="user">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["User"]} />
                </div>
                <div
                  className="col text-end"
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "end",
                  }}
                >
                  <Tippy content="Filter">
                    <img
                      src={filter}
                      onClick={() => handleFilterVisibility()}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>

                  <Link
                    onClick={(v) => {
                      handleShow();
                      setShowId(1);
                    }}
                    className="btn btn-primary px-4 py-2"
                    style={{
                      height: "33px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Add User
                  </Link>
                </div>
              </div>
              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  autoComplete="off"
                >
                  <div className="row" id="userAdd">
                    <div className="col-md">
                      <label htmlFor="user_name">User Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="user_name"
                        value={formInputs.user_name}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="user_mob">Mobile</label>
                      <input
                        type="text"
                        className="form-control"
                        id="user_mob"
                        maxLength={13}
                        onKeyDown={inputNumber}
                        onPaste={handlePaste}
                        value={formInputs.user_mob}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="default_godown">Status</label>
                      <select
                        className="form-select"
                        value={formInputs.is_active}
                        onChange={handleInputs}
                        id="is_active"
                      >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">In-Active</option>
                      </select>
                    </div>
                    <div
                      className="col-md-4 mt-auto"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "end",
                        float: "right",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2"
                        type="button"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                          background: "#4263eb",
                          fontSize: "14px",
                        }}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {(error || success) && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-${
                        error ? "danger" : "success"
                      } py-1 small`}
                      role="alert"
                    >
                      {error || success || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col">
                  <table className={`table ${error ? "my-1" : "mt-4"} rounded`}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Mobile</th>
                        <th>Role</th>
                        <th>Location</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length === 0) && (
                        <tr>
                          <td colSpan="7" className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list.map((v, i) => {
                        if (v.role_id !== 1) {
                          return (
                            <tr key={`ul_` + i}>
                              <td>{currentPage * 10 - 10 + i + 1}</td>
                              <td>{v.user_name}</td>
                              <td>{v.user_mob}</td>
                              <td>
                                {roleListIng.find(
                                  (list) => list.id === v.role_id,
                                )?.title || "N/A"}
                              </td>
                              <td>
                                {v.role_id == 2
                                  ? "All Access"
                                  : v.role_id == 5
                                    ? v.user_godown?.godown_name
                                    : v.role_id == 3 ||
                                        v.role_id == 4 ||
                                        v.role_id == 7 ||
                                        v.role_id == 8 ||
                                        v.role_id == 9
                                      ? v.user_branch?.branch_name
                                      : "NA"}
                              </td>
                              <td>
                                {v.user_id !== user.user_id ? (
                                  <Tippy content="Change Status">
                                    {v.is_active ? (
                                      <span
                                        className="badge text-bg-success"
                                        role="button"
                                        onClick={() =>
                                          changeStatus(v.user_id, 0)
                                        }
                                      >
                                        Active
                                      </span>
                                    ) : (
                                      <span
                                        className="badge text-bg-danger"
                                        role="button"
                                        onClick={() =>
                                          changeStatus(v.user_id, 1)
                                        }
                                      >
                                        In-Active
                                      </span>
                                    )}
                                  </Tippy>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>
                                <Tippy content="View" trigger="mouseenter">
                                  <a
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setEditId(v);
                                      handleShow();
                                      setShowId(3);
                                    }}
                                  >
                                    <img
                                      src={view}
                                      className="img-fluid me-2"
                                      alt=""
                                    />
                                  </a>
                                </Tippy>

                                {/*{v.user_id !== user.user_id ? ( */}
                                <Tippy content="Edit" trigger="mouseenter">
                                  <Link
                                    // to={`/user/edit/` + v.user_id}
                                    onClick={() => {
                                      setEditId(v);
                                      handleShow();
                                      setShowId(2);
                                    }}
                                    className={`link-info ${
                                      v.is_active ? "" : "d-none"
                                    }`}
                                  >
                                    <img
                                      src={editIcon}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </Link>
                                </Tippy>
                                {v.role_id == 10 && v?.device_id && (
                                  <Tippy
                                    content="Clear Device"
                                    trigger="mouseenter"
                                  >
                                    <span
                                      style={{
                                        marginLeft: "10px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        clearDevice(v.user_id);
                                      }}
                                    >
                                      <TbCircleArrowUpRight
                                        size={23}
                                        color="blue"
                                      />
                                    </span>
                                  </Tippy>
                                )}
                                {/* ) : ( */}
                                {/* "" */}
                                {/* )} */}
                              </td>
                            </tr>
                          );
                        }
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    // nPages={Math.ceil(list.length / 10)}
                    nPages={Math.ceil(totalPage / 10)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
              <Modal
                show={show}
                onHide={handleClose}
                keyboard={false}
                backdrop="static"
              >
                {showId == 1 ? (
                  <UserAdd
                    id={editId}
                    list={getList}
                    hide={handleClose}
                    roles={roleList}
                    brList={brList}
                    godowList={godowList}
                    companyListMap={companyListMap}
                  />
                ) : showId == 2 ? (
                  <UserEdit
                    id={editId}
                    list={getList}
                    hide={handleClose}
                    roles={roleList}
                    brList={brList}
                    godowList={godowList}
                    companyListMap={companyListMap}
                  />
                ) : showId == 3 ? (
                  <UserEditView
                    id={editId}
                    list={getList}
                    hide={handleClose}
                    brList={brList}
                    godowList={godowList}
                    companyListMap={companyListMap}
                  />
                ) : null}
              </Modal>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default UserList;
